import React, { useMemo } from 'react';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { isEqual } from 'lodash';

import './group-by-dropdown.scss';

const dropDownTrigger: ('click' | 'hover')[] = ['click'];

export interface GroupByOption {
	title: string;
	value: string[];
	translationKey: string;
}

interface Props {
	options: GroupByOption[];
	groupBy: string[];
	setGroupBy: (ids: string[]) => void;
}

function GroupByDropdown({ options, groupBy, setGroupBy }: Props) {
	const { t } = useTranslation();

	const selectedOption = useMemo(() => {
		return options.find(item => isEqual(groupBy, item.value));
	}, [groupBy, options]);

	const items = useMemo(
		() =>
			options.map(o => ({
				key: o.title,
				'data-i18n-key': o.translationKey,
				label: o.title,
				onClick: () => setGroupBy(o.value as string[])
			})),
		[options, setGroupBy]
	);

	return (
		<Dropdown menu={{ items }} trigger={dropDownTrigger}>
			<div className="group-by-dropdown">
				<span className="group-by-prefix">{t('EXCEPTIONS_LIST.GROUP_BY')}:</span>
				<span className="group-by-value">
					{selectedOption.title}
					<BringgIcon iconName={BringgFontIcons.Chevron} />
				</span>
			</div>
		</Dropdown>
	);
}

export default observer(GroupByDropdown) as typeof GroupByDropdown;
